import {Injectable} from '@angular/core';
import {Ordine, STATO_ORDINE, TIPO_ORDINE} from "../models/Ordine";
import {DialogService} from "../components/generics/dialog/dialog.service";
import {FormControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import _ from "lodash";
import {
   PVariantInstanceModalComponent
} from "../pages/root/esercizio/pvendita/pv-ordini-fornitori/pv-ordine-fornitore/pvariant-instance-modal/pvariant-instance-modal.component";
import {OrdineSlave} from "../models/OrdineSlave";
import {GuiService} from "./gui.service";
import {ServerService} from "./server.service";
import {PVenditaProdVarInst} from "../models/PVenditaProdVarInst";
import {ImageZoomComponent} from "../components/generics/image-zoom/image-zoom.component";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import moment from "moment";
import {Observable, Subject} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";

@Injectable({
   providedIn: 'root'
})
export class OrdineService {
   imageDialog!: MatDialogRef<any>
   component;
   private ordineSubject = new Subject<any>();
   n_resi = 0

   constructor(
      private dialogSrv: DialogService,
      private dialog: MatDialog,
      private guiSrv: GuiService,
      private serverSrv: ServerService,
      private router: Router,
      private route: ActivatedRoute
   ) { }

   searchBarcode($e):void{
      if ($e[0] && $e[1]){
         let pVenditaProdVarInst = $e[1]
         try {
            let foundBarcode = this.hasBarcode($e[0], this.component.prodotti)
            if (foundBarcode){
               this.dialogSrv.showToastError({err: "Barcode già inserito", msg:"Errore Prodotto"});
            } else {
               this.addIstanza(pVenditaProdVarInst, $e[0])
            }
         }catch (e) {
            this.dialogSrv.showToastError({err: e, msg:"Errore"});
         }
      }
   }

   hasBarcode(code, prodotti) {
      if (!code) return false;
      for (let prod of prodotti.controls){
         let barcodes = prod.get('barcodes')
         let barcode = _.find(barcodes.controls, (x:any) => x.value == code)
         if (barcode){
            return true
         }
      }
      return false;
   }

   addIstanza(istanza: PVenditaProdVarInst, barcode:any=null, orderHasTotal=false, type='prodotto') {
      console.log(istanza)
      console.log("STAQUA")

      if (type != 'altro'){
         let istanzaExist = _.find(this.component.prodotti.controls, x => x.controls.instance_id.value == istanza.data.id)
         if (istanzaExist){

            console.log(istanzaExist)
            if (istanza.data?.qta! - (istanzaExist.controls.qta.value + 1) < 0){
               this.dialogSrv.showToastError({title:"Aggiunta prodotto", err:"Non puoi aggiungere altri prodotti perchè superano la quantità totale"})
               return
            }

            istanzaExist.controls.qta.patchValue(istanzaExist.controls.qta.value + 1)

            if (istanza.data.is_barcode)
               istanzaExist.controls.barcodes.controls.push(new UntypedFormControl(barcode))

         }else {
               let riga = this.component.prodotti.length + 1

               const prezzoListino = Number(istanza.data.prezzo_listino);
               const prezzoListinoBase = Number(istanza.data.prezzo_listino_base);

               const prezzoVendita = prezzoListino > 0
                  ? prezzoListino
                  : prezzoListinoBase > 0
                     ? prezzoListinoBase
                     : 0;

               this.component.prodotti.push(new UntypedFormGroup({
               riga: new UntypedFormControl(riga),
               id: new UntypedFormControl(null),
               label_product: new UntypedFormControl({value:null, disabled:true}),
               image: new UntypedFormControl(istanza.data.image),
               instance_id: new UntypedFormControl(istanza.data.id),
               prod_var_instance_id: new UntypedFormControl(istanza.data.prod_var_instance_id ? istanza.data.prod_var_instance_id : istanza.data.instance),
               ean: new UntypedFormControl(istanza.data.ean ? istanza.data.ean : "NO EAN"),
               metrica: new UntypedFormControl(istanza.data.metrica_str),
               colore: new UntypedFormControl(istanza.data.prodotto__colore_str),
               nome: new UntypedFormControl(istanza.data.prodotto__nome),
               codice: new UntypedFormControl(istanza.data.prodotto__codice),
               brand: new UntypedFormControl(istanza.data.prodotto__brand__name),
               total_gross: new UntypedFormControl({value: prezzoVendita, disabled: true}),
               prezzo_acquisto_min: new UntypedFormControl(istanza.data.prezzo_acquisto_min),
               prezzo_acquisto_max: new UntypedFormControl(istanza.data.prezzo_acquisto_max),
               prezzo_listino_base: new UntypedFormControl(prezzoListinoBase),
               sconto: new UntypedFormControl(0),
               total: new UntypedFormControl(prezzoVendita),
               qta: new UntypedFormControl({value:1, disabled:true}),
               qta_disp: new UntypedFormControl({value:istanza.data.qta, disabled:true}),
               qta_reso: new UntypedFormControl({value:0}),
               barcodes: new UntypedFormArray([]),
               type:new UntypedFormControl(type)
            }))
            if (istanza.data.is_barcode)
               this.component.prodotti.controls[this.component.prodotti.length - 1].get('barcodes').push(new UntypedFormControl(barcode))
         }
      }else {
         let riga = this.component.prodotti.length + 1
         this.component.prodotti.push(new UntypedFormGroup({
            riga: new UntypedFormControl(riga),
            id: new UntypedFormControl(null),
            label_product: new UntypedFormControl('', Validators.required),
            image: new UntypedFormControl(null),
            instance_id: new UntypedFormControl(null),
            prod_var_instance_id: new UntypedFormControl(null),
            ean: new UntypedFormControl(null),
            metrica: new UntypedFormControl(null),
            colore: new UntypedFormControl(null),
            nome: new UntypedFormControl(null),
            codice: new UntypedFormControl(null),
            brand: new UntypedFormControl(null),
            total_gross: new UntypedFormControl(0),
            prezzo_acquisto_min: new UntypedFormControl(0),
            prezzo_acquisto_max: new UntypedFormControl(0),
            prezzo_listino_base: new UntypedFormControl(0),
            sconto: new UntypedFormControl(0),
            total: new UntypedFormControl(0),
            qta: new UntypedFormControl({value:1, disabled:true}),
            qta_disp: new UntypedFormControl({value:1000, disabled:true}),
            qta_reso: new UntypedFormControl({value:0}),
            barcodes: new UntypedFormArray([]),
            type:new UntypedFormControl(type)
         }))
      }
      this.dialogSrv.showToastSuccess({title:"Aggiungi prodotto", msg:"Prodotto aggiunto"})
      this.calculateTotal(orderHasTotal)
   }

   checkDisponibility(qtaValue, i){
      let diffQta = this.component.prodotti.controls[i].get('qta').value + qtaValue
      let qtaTot = this.component.prodotti.controls[i].get('qta_disp').value
      let tot = qtaTot - diffQta
      return tot >= 0;
   }

   changeQta(qtaValue: number, i: number, hasTotals:boolean) {
      // has_totals lo uso per le vendite per trattare anche i dati dei prezzi totali

      if (qtaValue < 0){
         let barcodExist = this.component.prodotti.controls[i].get('barcodes').controls.length > 0

         if (barcodExist){
            clearInterval(this.component.interval)
            this.component.isShowModalDeleteBarcode = true
            this.component.indexSel = i
            this.component.itemSel = this.component.prodotti.controls[i]
         }else {

            this.component.prodotti.controls[i].get('qta').patchValue(this.component.prodotti.controls[i].get('qta').value + qtaValue)

            // Controllo se viene inserita una qta minore di 0
            if (this.component.prodotti.controls[i].get('qta').value < 0){
               this.dialogSrv.showError({title:"Quantità prodotto", msg:"Attenzione! Non puoi inserire un numero negativo nelle quantità."})
               this.component.prodotti.controls[i].get('qta').patchValue(1)
            }

            // Controllo se viene inserita una qta uguale a 0
            if (this.component.prodotti.controls[i].get('qta').value == 0){
               this.component.prodotti.controls[i].get('qta').patchValue(1)

               this.component.isShowModalDeleteBarcode = false
               this.component.indexSel = i
               this.component.itemSel = this.component.prodotti.controls[i]
               this.component.clickRemoveElementCart(i)
            }
         }
      }else {
         this.component.prodotti.controls[i].get('qta').patchValue(this.component.prodotti.controls[i].get('qta').value + qtaValue)
      }
      this.calculateTotal(hasTotals)
   }

   clickRemoveQtaAndBarcode(code, prodotto, hasTotals): void {
      if (code){
         let index = _.findIndex(prodotto.get('barcodes').controls, (x:any) => x.value == code)
         let barcodeExist = _.find(prodotto.get('barcodes').controls, x=>x.value == code)

         if (barcodeExist){
            prodotto.get('barcodes').removeAt(index)
            prodotto.get('qta').patchValue(prodotto.get('qta').value - 1)
         }else {
            this.dialogSrv.showToastError({title:"Barcode", err:"Attenzione! Questo barcode non può essere eliminato perchè non è stato inserito"})
         }
      }
      else {
         prodotto.get('qta').patchValue(prodotto.get('qta').value - 1)
      }
      if (this.component.itemSel.get('qta')?.value == 0){
         this.component.clickRemoveElementCart(this.component.indexSel)
         this.component.isShowModalDeleteBarcode = false
      }
      this.calculateTotal(hasTotals)
   }

   calculateTotal(hasTotals=false):Promise<any>{
      return new Promise<any>((resolve, reject) => {
         let totNoSconto:number = 0
         if (hasTotals){
            this.component.prodottiFrm.controls.total_gross.patchValue(0)
            this.component.prodottiFrm.controls.total.patchValue(0)
            this.component.prodottiFrm.controls.total_acquisto_min.patchValue(0)
            this.component.prodottiFrm.controls.total_acquisto_max.patchValue(0)
         }

         let qta_tot = 0
         for (let prod of this.component.prodotti.controls){
            let qta = prod.controls.qta.value
            if (hasTotals){
               let total_gross_instance = prod.controls.total_gross.value
               let total_instance:number = Number(prod.controls.total.value)
               let total_acquisto_max_instance = prod.controls.prezzo_acquisto_max.value
               let total_acquisto_min_instance = prod.controls.prezzo_acquisto_min.value

               total_gross_instance = total_gross_instance * qta
               total_instance = total_instance * qta
               total_acquisto_max_instance = total_acquisto_max_instance * qta
               total_acquisto_min_instance = total_acquisto_min_instance * qta

               totNoSconto = totNoSconto + total_instance
               this.component.prodottiFrm.controls.total_gross.patchValue((Number(this.component.prodottiFrm.controls.total_gross.value) + total_gross_instance).toFixed(2))
               this.component.prodottiFrm.controls.total.patchValue((Number(this.component.prodottiFrm.controls.total.value) + total_instance).toFixed(2))
               this.component.prodottiFrm.controls.total_nosconto.patchValue(totNoSconto.toFixed(2))
               this.component.prodottiFrm.controls.total_acquisto_max.patchValue((Number(this.component.prodottiFrm.controls.total_acquisto_max.value) + total_acquisto_max_instance).toFixed(2))
               this.component.prodottiFrm.controls.total_acquisto_min.patchValue((Number(this.component.prodottiFrm.controls.total_acquisto_min.value) + total_acquisto_min_instance).toFixed(2))

               // console.log(this.component.isPuntoCassa)
               // if (this.component.isPuntoCassa){
               //    console.log(this.component.ordine)
               //    this.component.ordine.data.total = this.component.prodottiFrm.controls.total.value
               // }
            }

            qta_tot = qta_tot + qta
            this.component.prodottiFrm.controls.qta_tot.patchValue(qta_tot)
            console.log(this.component.isPuntoCassa)
         }

         // Sconto Flat
         if (this.component.variabili){
            for (let variable of this.component.variabili.controls){
               if (variable.controls.tipo.value == Ordine.TipoScontoChoices.FLAT || variable.controls.tipo.value == Ordine.TipoScontoChoices.BUONO){
                  this.component.prodottiFrm.controls.total.patchValue(((Number(this.component.prodottiFrm.controls.total.value) - variable.controls.sconto.value)).toFixed(2))
                  variable.controls.valore_sconto.patchValue(variable.controls.sconto.value * -1)
               }

               if (variable.controls.tipo.value == Ordine.TipoScontoChoices.PERCENTUALE){
                  let sconto_perc = variable.controls.sconto.value
                  let total = this.component.prodottiFrm.controls.total.value
                  let tot_sconto = total * sconto_perc / 100
                  this.component.prodottiFrm.controls.total.patchValue(((Number(this.component.prodottiFrm.controls.total.value) - tot_sconto)).toFixed(2))
                  variable.controls.valore_sconto.patchValue((tot_sconto * -1).toFixed(2))
               }
            }
         }

         if (this.component.prodottiFrm.controls.imponibile)
            this.component.prodottiFrm.controls.imponibile.patchValue((Number(this.component.prodottiFrm.controls.total.value) / (1+(this.component.prodottiFrm.controls.aliquota.value / 100))).toFixed(2))

         if (this.component.prodottiFrm.controls.total_tax){
            this.component.prodottiFrm.controls.total_tax.patchValue((Number(this.component.prodottiFrm.controls.total.value - this.component.prodottiFrm.controls.imponibile.value)).toFixed(2))
         }

         if (this.component.prodottiFrm.controls.iva_non_applicabile.value){
            this.component.prodottiFrm.controls.imponibile.patchValue(this.component.prodottiFrm.controls.total.value)
            this.component.prodottiFrm.controls.total_tax.patchValue(0)
         }

         if (this.component.isPuntoCassa){
            this.component.ordine.data.total = this.component.prodottiFrm.controls.total.value
         }
         resolve(true)
      }).catch()

   }

   clickSearchVariant() {
      let dialogRef = this.component.dialog.open(PVariantInstanceModalComponent, {
         height: '600px',
         width: 'auto',
         panelClass: "modal-nopadding",
         data:{
            vendorSlug:this.component.vendorSlug,
            pVenditaID: this.component.pVenditaId,
            excludeNotOrdered: true,
            isModal: true
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         this.component.pVariant = result.pVariant
         if (result) this.clickOpenModalIstanze()
      });
   }

   clickOpenModalIstanze(cliente_id= null){
      let dialogRef = this.component.dialog.open(this.component.instancesTemplate, {
         height: '800px',
         width: 'auto',
         panelClass: "modal-nopadding",
         data:{
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         // if (result) this.clickOpenModalIstanze(result.pVariant)
      });
   }

   clickRemoveElementCart(i: number, url, id_prod, hasTotals=false){
      clearInterval(this.component.interval)
      this.dialogSrv.showConfirmAlt({title:"Elimina Prodotto", msg:"Vuoi davvero eliminare il prodotto?", show_confirm_alt_red:true}).then((res)=> {
         this.component.prodotti.removeAt(i)

         // Sistemo numero riga
         for (let j = i; j < this.component.prodotti.controls.length; j++) {
            this.component.prodotti.controls[j].controls.riga.patchValue(this.component.prodotti.controls[j].controls.riga.value - 1)
         }

         if (id_prod){
            this.guiSrv.showLoading()
            this.serverSrv.delete(url,
               {}, OrdineSlave).then(res => {
               setTimeout(() => {
                  this.component.clickSave.emit()
               },1000)
               this.guiSrv.hideLoading()
            }).catch(err => {
               console.error(err)
               this.guiSrv.hideLoading()
            })
         }

         this.component.isShowModalDeleteBarcode = false
         // Ricalcolo totale
         this.calculateTotal(hasTotals)
         this.dialogSrv.showToastSuccess({title:"Elimina prodotto", msg:"Prodotto eliminato"})
         this.component.onUpdateCart.emit()
      })
   }

   async patchValueFrmOrdiniSlave(hasVariables= false, hasTotals = false){
      this.n_resi = _.sumBy(this.component.ordiniSlave, 'data.qta_reso')

      if (this.component.ordiniSlave.length > 0){
         this.component.prodotti.controls = []

         for (let ordineSlave of this.component.ordiniSlave){
            console.log(ordineSlave)
            let vendorProdVarInst = ordineSlave.data.vendor_prod_var_instance

            this.component.prodotti.push(new UntypedFormGroup({
                  riga: new UntypedFormControl(ordineSlave.data.riga),
                  id: new UntypedFormControl(ordineSlave.data.id),
                  label_product: new UntypedFormControl(ordineSlave.data.label_product),
                  image: new UntypedFormControl(ordineSlave.data.image),
                  instance_id: new UntypedFormControl(ordineSlave.data.pvendita_prod_var_instance ? ordineSlave.data.pvendita_prod_var_instance : null),
                  prod_var_instance_id: new UntypedFormControl(ordineSlave.data.prod_var_instance_id ? ordineSlave.data.prod_var_instance_id : null),
                  ean: new UntypedFormControl(ordineSlave.data.ean),
                  metrica: new UntypedFormControl(vendorProdVarInst ? ordineSlave.data.vendor_prod_var_instance.metrica_str : ''),
                  colore: new UntypedFormControl(vendorProdVarInst ? vendorProdVarInst.p_variant.colore_str : ''),
                  nome: new UntypedFormControl(vendorProdVarInst ? vendorProdVarInst.p_variant.prodotto.nome : ''),
                  codice: new UntypedFormControl(vendorProdVarInst? vendorProdVarInst.p_variant.codice : ''),
                  brand: new UntypedFormControl(vendorProdVarInst? vendorProdVarInst.p_variant.prodotto.brand__name : ''),
                  total_gross: new FormControl({value:ordineSlave.data.total_gross, disabled:true}),
                  prezzo_acquisto_min: new UntypedFormControl(ordineSlave.data.prezzo_acquisto_min),
                  prezzo_acquisto_max: new UntypedFormControl(ordineSlave.data.prezzo_acquisto_max),
                  prezzo_listino_base: new UntypedFormControl(ordineSlave.data.prezzo_listino_base),
                  sconto: new UntypedFormControl(ordineSlave.data.sconto),
                  total: new UntypedFormControl(ordineSlave.data.total),
                  qta: new UntypedFormControl({value:ordineSlave.data.qta, disabled:true}),
                  qta_disp: new UntypedFormControl({value:vendorProdVarInst ? ordineSlave.data.qta_disp : 1000, disabled:true}),
                  qta_reso: new UntypedFormControl({value:vendorProdVarInst ? ordineSlave.data.qta_reso : 0, disabled:true}),
                  barcodes: new UntypedFormArray([]),
                  type: new UntypedFormControl(ordineSlave.data.label_product ? 'altro' : 'prodotto')
               })
            )

            // console.log(this.component.prodotti)
            // for (const vendorProdVarInstKey in this.component.prodotti.controls) {
            //    console.log(this.component.prodotti.controls[vendorProdVarInstKey])
            //
            //    let total_gross = this.component.prodotti.controls[vendorProdVarInstKey].get('total_gross').disable()
            //    total_gross.patchValue(1010)
            //    total_gross.disable()
            //    console.log(total_gross.disabled)
            //
            // }

            if (ordineSlave.data.barcodes.length > 0){
               for (let barcode of ordineSlave.data.barcodes!){
                  console.log(barcode)
                  this.component.prodotti.controls[this.component.prodotti.length - 1].get('barcodes').push(new UntypedFormControl(barcode))
               }
            }

         }
      }
      if (hasVariables) this.patchValueVariabili()
      this.calculateTotal(hasTotals)
   }

   // Usato per gli sconti delle vendite
   patchValueVariabili(){
      this.component.variabili.controls = []
      if (this.component.ordine.data.sconti_ordini){
         for (let sconto of this.component.ordine.data.sconti_ordini) {
            if (sconto.tipo == 'sco_flat' || sconto.tipo == 'sco_perc' || sconto.tipo == 'buo') {
               let suffix = '€'
               if (sconto.tipo == 'sco_perc') suffix = '%'
               let sco = _.find(Ordine.TipoSconto, x => x.value == sconto.tipo)
               this.component.variabili.push(new UntypedFormGroup({
                  id: new UntypedFormControl(sconto.id),
                  ordine: new UntypedFormControl(sconto.ordine),
                  sconto: new UntypedFormControl(Number(sconto.sconto)),
                  valore_sconto: new UntypedFormControl({value:0, disabled:true}),
                  tipo: new UntypedFormControl(sconto.tipo),
                  riga: new UntypedFormControl(sconto.riga),
                  name: new UntypedFormControl(sco?.display),
                  suffix: new UntypedFormControl(suffix),
               }))
            }
         }
      }
   }

   openImage(data:any) {

      console.log(data)

      // this.imageSel = this.openLink(data.image)

      this.imageDialog = this.dialog.open(ImageZoomComponent, {
         disableClose:false,
         maxWidth: '90vw',
         width: '800px',
         maxHeight: '90vh',
         height: 'auto',
         panelClass: 'my-dialog',
         data:{
            'data':data,
            'prod_var_instance_id':data.get('prod_var_instance_id').value,
            'vendorSlug':this.component.vendorSlug
         }
      });
      this.imageDialog.afterClosed().subscribe(result => {
         // if (result) this.clickOpenModalIstanze(result.pVariant)
      });
   }

   openLink(url){
      return this.serverSrv.getPrivateMedia(url)
   }

   async saveOrder(isBozza, saveExit=false,
                   spedito=false,
                   tipoOrdine: string,
                   infoComponent,
                   composizioneComponent,
                   spedizioneComponent:any=null,
                   pagamentoComponent:any=null,
                   queryParams='',
                   isPuntoCassa=false,
                   clienteId:number|null=null,
                   isNascosto:boolean=false

   ) {

      return new Promise((resolve, reject) => {
         this.guiSrv.showLoading()
         let ordineId = null

         // Salvo informazioni generali
         if (infoComponent){
            infoComponent.infoOrdineFrm?.markAllAsTouched()
            if ( infoComponent.infoOrdineFrm?.valid){
               if ( infoComponent.infoOrdineFrm?.value.data_creazione != null)
                  infoComponent.infoOrdineFrm?.get('data_creazione')?.patchValue(moment(infoComponent.infoOrdineFrm.value.data_creazione).format("YYYY-MM-DD"))
            }
         }

         let data:{} = {
            is_nascosto: isNascosto,
            is_bozza: isBozza,
            prodotti: composizioneComponent.prodottiFrm?.getRawValue(),
            spedito: spedito,
            cliente_id: clienteId
         }

         if (infoComponent){
            data['ordine'] = infoComponent.infoOrdineFrm?.getRawValue()
         }

         if (spedizioneComponent){
            data['spedizioni'] = spedizioneComponent.spedizioniFrm.getRawValue()
            data['spedizione_option'] = spedizioneComponent.optionCtrl.value
         }

         if (pagamentoComponent){
            if (!isPuntoCassa)
               data['pagamenti'] = pagamentoComponent.pagamentiSectionComponent.pagamentiArray.getRawValue()
            else
               data['pagamenti'] = pagamentoComponent.pagamentiArray.getRawValue()
         }

         // Salvo Slaves
         composizioneComponent.prodottiFrm?.markAllAsTouched()

         if (composizioneComponent.prodottiFrm?.valid || ((spedizioneComponent && spedizioneComponent.spedizioniFrm.valid) || !spedizioneComponent.spedizioniFrm.enabled)){
            let url = `/api/esercizi/${this.component.vendorSlug}/p_vendita/${this.component.pVenditaId}/${tipoOrdine}/${this.component.ordine.data.id}/ordini_slave`

            if (isPuntoCassa){
               url = `/api/esercizi/${this.component.vendorSlug}/p_vendita/${this.component.pVenditaId}/vendite/punto_cassa`
            }

            if (queryParams != '') url += queryParams
            this.serverSrv.post(url, data, null).then(res => {
               let ord_slave = res
               ord_slave = _.map(ord_slave, (d: any) => { return new OrdineSlave(d); })
               this.setValue({ordiniSlave:ord_slave})

               if (isPuntoCassa){
                  this.guiSrv.hideLoading()
                  this.dialogSrv.showToastSuccess({title:"Conferma ordine", msg:"Ordine confermato"})
                  ordineId = res.id
                  resolve(res)
                  return
                  // this.component.router.navigate(['../'], {relativeTo:this.component.route})
               }

               // AL SALVATAGGIO DELLA BOZZA FACCIO IL PATCHVALUE DEGLI ID DEI PRODOTTI, DEGLI SCONTI E DELLE SPEDIZIONI
               console.log("FETCHORDINE")
               this.fetchOrdine(tipoOrdine, ordineId).then((ordine:Ordine) => {
                  // if (composizioneComponent) composizioneComponent.ordine = ordine
                  // if (pagamentoComponent) pagamentoComponent.ordine = ordine
                  // if (infoComponent) infoComponent.ordine = ordine

                  this.setValue({ordine:ordine})

                  _.each(composizioneComponent.prodotti.controls, x => {
                     _.find(res, y => {
                        if (x.value.instance_id == y.pvendita_prod_var_instance) {
                           if (x.value.id == null) x.controls.id.patchValue(y.id)
                        }
                     })
                  })

                  if (spedizioneComponent){
                     _.each(spedizioneComponent.spedizioni.controls, x => {
                        _.find(ordine.data.spedizioni_ordini, y => {
                           if (x.value.riga == y.riga) {
                              if (x.value.id == null) x.controls.id.patchValue(y.id)
                           }
                        })
                     })
                  }

                  if (composizioneComponent.variabili){
                     _.each(composizioneComponent.variabili.controls, x => {
                        _.find(ordine.data.sconti_ordini, y => {
                           if (x.value.riga == y.riga) {
                              if (x.value.id == null) x.controls.id.patchValue(y.id)
                           }
                        })
                     })
                  }

                  if (ordine.data.tipo == TIPO_ORDINE.ESUBERO && ordine.data.stato == STATO_ORDINE.COMPLETO){
                     this.guiSrv.showLoading()
                     this.serverSrv.post(`/api/esercizi/${this.component.vendorSlug}/p_vendita/${this.component.pVenditaId}/ordini_fornitore/${ordine.data.id}/convalide`, {chiudi:true}).then(res => {
                        this.guiSrv.hideLoading()
                     }).catch(err => {
                        this.guiSrv.hideLoading()
                        console.error(err)
                     })
                  }

                  this.guiSrv.hideLoading()
                  if (this.component.ordine.data.stato == STATO_ORDINE.BOZZA) this.dialogSrv.showToastSuccess({title:"Salvataggio bozza", msg:"Dati salvati"})
                  else this.dialogSrv.showToastSuccess({title:"Conferma ordine", msg:"Ordine confermato"})
                  if (saveExit) {
                     this.component.router.navigate(['../'], {relativeTo:this.component.route})
                     resolve(true)

                     console.log(this.component)}

                  resolve(true)

               })
            }).catch(err => {
               console.error(err)
               this.dialogSrv.showToastError({title:"Conferma ordine", err:err})
               this.guiSrv.hideLoading()
            })
         }
      })

   }

   fetchOrdine(tipoOrdine, ordine_id=null, direction:string=''):Promise<Ordine>{
      console.log(tipoOrdine)
      let ordineId = ordine_id ? ordine_id : this.component.ordine.data.id
      return new Promise((resolve, reject) => {
         this.serverSrv.get(Ordine, `/api/esercizi/${this.component.vendorSlug}/p_vendita/${this.component.pVenditaId}/${tipoOrdine}/${ordineId}?dir=${direction}`, {}).then(res =>{
            this.component.ordine = res
            resolve(res)
         }).catch(err => {
            console.error(err)
            reject(err)
         })
      })
   }

   fetchOrdiniSlave(vendorSlug, pVenditaId, ordine_id):Promise<OrdineSlave[]>{
      let ordineId = ordine_id ? ordine_id : this.component.ordine.data.id
      return new Promise((resolve, reject) => {
         this.serverSrv.getAll(OrdineSlave, `/api/esercizi/${vendorSlug}/p_vendita/${pVenditaId}/ordini/${ordineId}/ordini_slave`, {}).then(res => {
            this.component.ordiniSlave = res
            console.log(res)
            resolve(res)
         }).catch(err => {
            console.error(err)
            reject(err)
         })
      })
   }

   // Funzione fix per click continuo su qta ordini
   handleOutsideClick() {
      if (this.component.isClickingOutside) {
         clearInterval(this.component.interval)
      }
      this.component.isClickingOutside = false; // Resetta il flag per il prossimo utilizzo
   }

   setValue(value: any) {
      this.ordineSubject.next(value);
   }

   getValue$(): Observable<any> {
      return this.ordineSubject.asObservable();
   }

}
